export default function accordionReducer (state = false, action) {
    switch (action.type) {
      case 'SET_ACCORDION':
        return action.payload;
      default:
        return state;
    }
  };
